import { FC } from 'react';
import type { Course } from '@teachur/http-client';
import { ChevronRight } from 'lucide-react';
import { Button } from '@new/common/ui';

interface ProjectDrawerCourseDetailsProps {
  courses?: Course[];
  onViewCourse?: (courseId: number) => void;
}

export const ProjectDrawerCourseDetails: FC<ProjectDrawerCourseDetailsProps> = ({
  courses,
  onViewCourse,
}) => {
  if (!courses?.length || !onViewCourse) return null;

  return (
    <div className="flex flex-wrap gap-2">
      {courses.map((course) => (
        <Button
          key={course.id}
          rightIcon={<ChevronRight size={14} />}
          onClick={() => onViewCourse(course.id)}
          size="xs"
          variant="inverted"
        >
          More details
        </Button>
      ))}
    </div>
  );
};
